import {
	AccountWithWalletsAndPermissions,
	CountResponse,
	createUnblockAccountMutation,
} from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type UnblockAccountModel = ConfirmModalModel<
	AccountWithWalletsAndPermissions,
	number,
	CountResponse
>;

export const createUnblockAccountModel = (): UnblockAccountModel => {
	const unblockAccountMutation = createUnblockAccountMutation();

	const model = createConfirmModalModel<AccountWithWalletsAndPermissions, number, CountResponse>({
		modalData: declareModalData<AccountWithWalletsAndPermissions>(),
		mapModalData: ({ id }) => id,
		mutation: unblockAccountMutation,
		successMessageKey: 'unblock-account.success',
	});

	return model;
};
